import { InternalMessageBusChannels } from "../../externals";
export class TokenHandler {
    constructor(storage, messageBus) {
        this.storage = storage;
        this.messageBus = messageBus;
    }
    onTokenChanged(token) {
        this.setToken(token);
        this.sendTokenRenewMessage(token);
    }
    setToken(token) {
        this.storage.setToken(token);
    }
    sendTokenRenewMessage(token) {
        const message = { token };
        this.messageBus.emit(InternalMessageBusChannels.legacy.anonymousJWTChange.renewJWTToken, message);
        this.messageBus.emit(InternalMessageBusChannels.authorization.renewJWTToken, message);
        this.messageBus.emit(InternalMessageBusChannels.legacy.platformJWTChange.renewJWTToken, message);
    }
}
//# sourceMappingURL=TokenHandler.js.map